import { Splash } from 'pwa/components';

const Main = () => {
  return <Splash />;
};

export default Main;
